import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {AppConfigurationService} from '@shared/app-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class HorizonSynchronizationService {

  private readonly _apiUrl: string;

  constructor(private _http: HttpClient, private _appConfig: AppConfigurationService) {
    this._apiUrl = `${this._appConfig.getConfig().apiUrl}`;
  }

  postSynchronizeHorizonStudent(schoolId: string, manualHorizonStudentSynchronizationId: string, studentId?: number): Observable<void> {
    return this._http.post<void>(`${this._apiUrl}/schools/${schoolId}/synchronizeHorizonStudent/${manualHorizonStudentSynchronizationId}`, {studentId});
  }

  postImportHorizonStudent(schoolId: string, horizonStudentId?: string): Observable<{id: number}> {
    return this._http.post<{id: number}>(`${this._apiUrl}/schools/${schoolId}/importHorizonStudent`, {horizonStudentId});
  }
}
